import React from 'react'
import addMonths from 'date-fns/addMonths'
import priceUtils from './price'
import {
  CURRENCY,
} from 'settings/payment'

const PerMonth = () => {
  return (
    <span style={{fontSize: '0.8em', color: '#666'}}> per month</span>
  )
}

const getLineItemsInfo = (subscriptionLineItems, productMap) => {
  const currency = CURRENCY
  if(!subscriptionLineItems || !productMap) return {
    currency,
    lineItems: [],
    total: 0,
  }
  
  const lineItems = subscriptionLineItems.map(item => {
    const qty = item.quantity
    const price = item.price.unit_amount
    const product = productMap[item.price.product]
    if(!product) return null
    const title = product.name
    const total = qty * price
    return {
      mode: product.metadata.hardware,
      qty,
      price,
      title,
      total,
      currency,
    }
  }).filter(i => i)

  const total = lineItems.reduce((all, item) => all + item.total, 0)

  return {
    currency,
    lineItems,
    total,
  }  
}

const getSubscriptionInfo = (subscription, productMap) => {

  if(!subscription) return null

  const periodStartDate = new Date(subscription.current_period_start * 1000)
  const periodEndDate = new Date(subscription.current_period_end * 1000)

  const periodStart = periodStartDate.toLocaleDateString()
  const periodEnd = periodEndDate.toLocaleDateString()
  const nextPeriodStart = addMonths(periodEndDate, 1).toLocaleDateString()

  const {
    currency,
    lineItems,
    total,
  } = getLineItemsInfo(subscription.items.data, productMap)

  return {
    periodStart,
    periodEnd,
    nextPeriodStart,
    currency,
    lineItems,
    total,
  }  
}

const getLineItemsTable = (subscriptionLineItems, productMap) => {
  if(!subscriptionLineItems) return []

  const {
    lineItems,
    total,
  } = getLineItemsInfo(subscriptionLineItems, productMap)

  const lineItemData = lineItems
    .filter(lineItem => lineItem.qty > 0)
    .map(lineItem => {
      return {
        title: lineItem.title,
        value: (
          <span>
            { `${ lineItem.mode == 'dedicated' ? lineItem.qty + ' x ' : '' }${ CURRENCY }${ priceUtils.displayPrice(lineItem.price) }` } <PerMonth />
          </span>
        ),
      }
    })

  const totalItem = {
    title: <strong>Total</strong>,
    value: <span><strong>{ CURRENCY }{ priceUtils.displayPrice(total) }</strong> <PerMonth /></span>,
  }

  return lineItemData.concat(['-', totalItem])
}

const getProrationTable = (lines) => {
  if(!lines) return []

  return lines
    .map(lineItem => {
      return {
        title: lineItem.description,
        value: (
          <span>
            { `${ CURRENCY }${ priceUtils.displayPrice(lineItem.amount) }` }
          </span>
        ),
      }
    })
}

const getSubscriptionTable = (subscription, productMap) => {
  const info = getSubscriptionInfo(subscription, productMap || {})

  if(!info) return []

  const baseItems = [{
    title: 'Current Period Start',
    value: info.periodStart,
  },{
    title: 'Current Period End',
    value: info.periodEnd,
  }, '-']

  if(info.lineItems.length <= 0) return baseItems

  const lineItemRows = getLineItemsTable(subscription.items.data, productMap || {})

  return baseItems.concat(lineItemRows)
}

const utils = {
  CURRENCY,
  getLineItemsInfo,
  getSubscriptionInfo,
  getSubscriptionTable,
  getProrationTable,
  getLineItemsTable,
}

export default utils